<template>
  <el-form ref="form" :model="value" :rules="rules" label-width="90px">
    <el-form-item label="景区名称" prop="name">
      <el-input v-model="value.name"></el-input>
    </el-form-item>
    <el-form-item label="设为热门" prop="isHot">
      <el-checkbox v-model="value.isHot"></el-checkbox>
    </el-form-item>
    <el-form-item label="景区描述" prop="description">
      <el-input v-model="value.description" type="textarea">
      </el-input>
    </el-form-item>
<!--    <el-form-item label="景区区域" prop="division">-->
<!--      <el-cascader-->
<!--          style="width: 500px;"-->
<!--          v-model="value.division"-->
<!--          :options="division"-->
<!--          :props="{checkStrictly: true}"-->
<!--      ></el-cascader>-->
<!--    </el-form-item>-->
    <el-form-item label="景区导航" prop="location">
      <baidu-map v-if="!loading" v-model:value="value.location" v-model:preset="value.division"/>
    </el-form-item>
<!--    <el-form-item label="详细地址" prop="divisionDetail">-->
<!--      <el-input v-model="value.divisionDetail"></el-input>-->
<!--    </el-form-item>-->
    <el-form-item label="相关图片" prop="pictures">
      <image-uploader
          :loading="loading"
          @update:loading="l => this.loading = l"
          :max-count="4"
          :value="value.pictures"
      />
    </el-form-item>
    <el-form-item label="需要预约" prop="needBooking">
      <el-checkbox v-model="value.needBooking"></el-checkbox>
    </el-form-item>
    <el-form-item label="预约日限（人）" prop="needBooking">
      <el-input v-model="value.maxBookingCount"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit" :disabled="loading">
        {{ isEdit ? '确认更新' : '确认录入' }}
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import division from '../../../constants/divisions.json'
import {computed, reactive, ref} from 'vue'
import axios from '../../../request'
import ImageUploader from '../../../components/ImageUploader'
import BaiduMap from '../../../components/BaiduMap'

export default {
  props: ['value'],
  components: {BaiduMap, ImageUploader},
  setup(props) {
    const form = ref('')
    const loading = ref(false)

    const rules = reactive({
      name: [{required: true, message: '必须填写'}],
      pictures: [{
        required: true, message: '至少上传一张图片', validator(rule, value, cb) {
          if (value?.length > 0) {
            cb()
          } else {
            cb('至少上传一张图片')
          }
        }
      }],
      location: [{required: true, message: '必须填写'}],
    })

    const isEdit = computed(() => !!props.value.id)

    const submit = () => {
      form.value?.validate(pass => {
        if (pass) {
          const pictures = props.value.pictures.map((v)=>{
            if(v.response){
              return v.response.files[0].url
            }
            return v.url
          })
          console.log(pictures)
          const data = {
            scenicSpot: {
              ...props.value,
              pictures,
              division: props.value.division.join(','),
            }
          }
          console.log(data)
          loading.value = true
          axios(isEdit.value ? {
            method: 'patch',
            url: `/scenic_spots/${props.value.id}`,
            data
          } : {
            method: 'post',
            url: '/scenic_spots',
            data
          }).then(() => {
            if(!props.value.id){
              props.value.pictures = []
              props.value.name = ''
              props.value.description = ''
              props.value.division = []
              props.value.divisionDetail = ''
              props.value.location = ''
            }
          }).finally(() => {
            loading.value = false
          })
        }
      })
    }

    return {
      form,
      isEdit,
      rules,
      division,
      loading,
      submit
    }
  }
}
</script>
